// MAKING CONTROLLER FUNCTION MORE EXPLICIT
// We used to pass "kw" to the controller as an optional parameter when we want to
// search by the keyword. But how do other developers know if the "kw" is an optional
// or not and what does "kw" actually mean? They have to read the documentation
// everytime when they use the controller which takes time and time is precious.
//
// Instead, explicitly declare another controller called searchStudentSummary.
// The name tells everything.
import axios from "axios";
import queryString from 'query-string';
import Joi from 'joi-browser';

import getStudentSummary, { schema as getStudentSummarySchema } from "./getStudentSummary";
import STUDENT_STATES from "../../constants/student-states";

const TOKEN = localStorage.getItem('token');

// we add a key called searchKeyword in schema
export const schema = getStudentSummarySchema.keys({
		searchKeyword: Joi.string().required().label("searchKeyword: kw-搜索字符，注：当kw为空时，按照参数2的条件进行搜索，如果有kw时，联合参数和参数3 kw 进行搜索"),
	});

export default function searchStudentSummary(opts) {
	let { error } = Joi.validate(opts, schema);

	if (error) {
		throw error;
	}

  return getStudentSummary({
    ...opts
  });
  
}



// WEBPACK FOOTER //
// ./src/controllers/controllers/student/searchStudentSummary.js